export default "__VITE_ASSET__WkELJ5Cd__"